import { useFetch, ISelectCountry } from "@4uhub/lib4uhub";
import { Grid, Typography } from "@mui/material";
import { memo, useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import FormInput from "../../../../../../components/UI/Inputs/FormInput";
import { getIndividualNumber } from "../../../../../../services/individual.service";
import { useFormContext } from "react-hook-form";
import { TAppointment } from "../../../schema";
import FormCheckBox from "../../../../../../components/UI/Inputs/FormCheckBox";

interface IAddCardFormProps {
  onGetSelectedCountry: (value: ISelectCountry | null) => void;
}

const ConfirmPhoneNumber: React.FC<IAddCardFormProps> = ({
  onGetSelectedCountry,
}) => {
  const { getValues, setValue } = useFormContext<TAppointment>();

  const { t } = useTranslation();

  const individualId = getValues("patient.individualId");

  const { sendRequest } = useFetch(getIndividualNumber);

  const fetchWhatsappNumber = useCallback(async () => {
    const { data, success } = await sendRequest({ IndividualId: individualId });
    if (data && success && data.value) {
      setValue("phoneNumberContact", data.value);
      setValue("isWhatsappPhoneNumberContact", data.isWhatsappMainNumber);
    }
  }, [sendRequest, setValue, individualId]);

  const handlePhoneBlur = useCallback(() => {
    const phoneValue = getValues("phoneNumberContact") || "";
    setValue("phoneNumberContact", phoneValue.trim());
  }, [getValues, setValue]);

  useEffect(() => {
    fetchWhatsappNumber();
  }, [fetchWhatsappNumber]);

  return (
    <>
      <Grid container spacing={1} alignItems="center">
        {" "}
        <Grid item xs={12} sm={12}>
          <Typography
            variant="subtitle1"
            color="textSecondary"
            fontWeight={600}
            gutterBottom
          >
            {t("page.schedules.newSchedule.confirm.confirm_contact_phone")}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={3}>
          <FormInput
            name="phoneNumberContact"
            label={t("page.schedules.newSchedule.confirm.phone_number")}
            size="small"
            fullWidth
            autoFocus
            onBlur={handlePhoneBlur}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormCheckBox
            name="isWhatsappPhoneNumberContact"
            label={
              t("page.schedules.newSchedule.confirm.main_whatsapp_number") ??
              "This is my main WhatsApp number"
            }
          />
        </Grid>
      </Grid>
    </>
  );
};

export default memo(ConfirmPhoneNumber);
